import * as React from "react";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import InfoModule from "../../../hiberUiKit/src/molecules/InfoModule/InfoModule";
import {Option} from "ts-option";
import Job from "../../../model/job/Job";
import DateUtils from "../../../utils/DateUtils";

interface Props {
	/**
	 * Job.
	 */
	job: Option<Job>
}

export default class JobCompleteDate extends React.PureComponent<Props, {}> {

	render() {
		const completeDate = this.props.job.flatMap(j => j.completedDateTime
			.map(date => date.format(DateUtils.JOB_COMPLETE_DATE_FORMAT))).getOrElse("Not specified");
		return (
			<InfoModule icon={Icon.Job} title={"JOB COMPLETE DATE"}>
				<span className="t-body">{completeDate}</span>
			</InfoModule>
		);
	}
}